export const GDPR_COUNTRY = [
  'DE',
  'NO',
  'FI',
  'BE',
  'PT',
  'BG',
  'DK',
  'LT',
  'LU',
  'HR',
  'LV',
  'FR',
  'HU',
  'SE',
  'MC',
  'SI',
  'SK',
  'MF',
  'SM',
  'GB',
  'YT',
  'IE',
  'GF',
  'EE',
  'MQ',
  'MT',
  'GP',
  'IS',
  'IT',
  'GR',
  'ES',
  'AT',
  'RE',
  'CY',
  'AX',
  'CZ',
  'PL',
  'RO',
  'LI',
  'NL',
]

export const LEGAL_PAGE_ROUTES = [
  'cookie_settings',
  'terms_of_use',
  'privacy_policy',
  'vendor_terms_of_use',
  'privacy_policy',
  'listing_guidelines',
  'community_guidelines',
  'content_compliance_policy',
  'glossary',
  'content_compliance_faqs',
  'reviews_faq',
]

export const RESOURCES_MAPPINGS = {
  resources_home: 'Resources/Homepage',
  'resources-all': 'Resources/All Articles',
  resources_post: 'Resources/Article',
  topics_home: 'Resources/All Topics',
  resources_topic: 'Resources/Topic',
  resources_author: 'Resources/Author',
  content_hub: 'Resources/Knowledge Base',
  press: 'Other/Press',
  category_leaders_methodology: 'Proprietary Insights/Software Methodology',
  category_leaders_badges: 'Proprietary Insights/Badges',
}
